/* HERO CINEMATIC ARRIVAL - driver for assets/amc-hero-cinematic.css.
   Loaded deferred by sections/amc-home-entry.liquid.

   SEQUENCE
     add html.amc-cine   the CSS now matches, hero copy is held hidden
     wait for the brand veil to lift and the player to be in the document
     .is-cine-in         frame opens from black, video eases out of its push-in,
                         copy rises in five steps
     .is-cine-settled    transitions off, scroll drift takes over

   WHY .amc-cine IS ADDED FROM SCRIPT
   The CSS holding the copy hidden is scoped to html.amc-cine. Adding that class
   here means a script failure leaves the hero fully visible instead of blank.

   THE 2.2s GUARANTEE
   open() runs on whichever comes first: the veil lifting, the player landing, or a
   hard 2.2s timer. It is idempotent. There is no path that leaves the copy hidden.

   THE VEIL
   snippets/amc-page-transition.liquid puts .amc-veil-on on <html> on a first visit
   and removes it when the veil lifts. Opening underneath the veil would finish the
   push-in behind a white screen, so the open waits for that class to clear.

   SCROLL DRIFT
   One rAF-throttled passive handler writing three custom properties. Only
   transform and opacity change, so it never triggers layout. It stops once the
   hero is off screen.

   DO NOT transform the player or the iframe - amc-hero-scrim.css crops those with
   container queries and sets transform:none on them. Transform the media wrapper. */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('amc-cine');

  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var OPEN_CAP = 2200;   // hard guarantee
  var SETTLE    = 2000;  // longest CSS transition in the open, plus its delay
  var PUSH      = 1.14;  // starting scale of the video
  var DRIFT     = 96;    // px the video travels down over one hero height
  var DRIFT_ZM  = 0.06;  // extra scale added across that same travel
  var DIM       = 0.52;  // how dark the plate goes at the bottom of the travel

  var hero = null, opened = false, settled = false, queued = false, capTimer = 0;

  function findHero() {
    return document.querySelector('.amc-opening-hero');
  }

  function setVars(scale, shift, fade, black) {
    if (!hero) return;
    var s = hero.style;
    s.setProperty('--cine-scale', String(scale));
    s.setProperty('--cine-shift', shift + 'px');
    s.setProperty('--cine-fade', String(fade));
    s.setProperty('--cine-black', String(black));
  }

  function settle() {
    if (settled || !hero) return;
    settled = true;
    hero.classList.add('is-cine-settled');
    bindScroll();
    paint();
  }

  function open() {
    if (opened) return;
    opened = true;
    clearTimeout(capTimer);
    if (!hero) hero = findHero();
    if (!hero) { root.classList.remove('amc-cine'); return; }
    hero.classList.add('is-cine-in');
    setVars(1, 0, 1, 0);
    setTimeout(settle, REDUCED ? 500 : SETTLE);
  }

  /* ---- scroll drift ---------------------------------------------------- */

  function paint() {
    queued = false;
    if (!hero || REDUCED) return;
    var box = hero.getBoundingClientRect();
    if (box.bottom <= 0) return;                 // hero is above the viewport
    var travelled = box.height ? Math.min(1, Math.max(0, -box.top / box.height)) : 0;
    setVars(1 + travelled * DRIFT_ZM, travelled * DRIFT, 1, travelled * DIM);
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(paint);
  }

  var scrollBound = false;
  function bindScroll() {
    if (scrollBound || REDUCED) return;
    scrollBound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---- start ----------------------------------------------------------- */

  function veilUp() {
    return root.classList.contains('amc-veil-on') ||
           !!document.querySelector('.amc-veil.is-active');
  }

  function start() {
    hero = findHero();
    if (!hero) { root.classList.remove('amc-cine'); return; }

    setVars(REDUCED ? 1 : PUSH, 0, REDUCED ? 1 : 0.28, 1);

    // Guarantee: the hero opens by this point whatever else is pending.
    capTimer = setTimeout(open, OPEN_CAP);

    if (!veilUp()) {
      // No veil in the way. One frame of held state, then open, so the browser
      // has a chance to paint the starting transform before the transition.
      requestAnimationFrame(function () { requestAnimationFrame(open); });
      return;
    }

    // Veil is up. Open the moment it clears.
    var watch = new MutationObserver(function () {
      if (!veilUp()) { watch.disconnect(); open(); }
    });
    watch.observe(root, { attributes: true, attributeFilter: ['class'] });
    var veilEl = document.querySelector('.amc-veil');
    if (veilEl) watch.observe(veilEl, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // A restore from the back/forward cache re-runs none of the above, and the hero
  // would come back mid-animation. Jump it straight to the settled state.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (!hero) hero = findHero();
    if (!hero) return;
    opened = true;
    hero.classList.add('is-cine-in');
    settle();
  });
})();
